const Status = {
  UNDEFINED: "undefined",
  SUCCESS: "success",
  WARNING: "warning",
  CRITICAL: "critical",
};

export default Status;
